import { alpha } from '@mui/material/styles'

export const grey = {
  0: '#FFFFFF',
  50: '#faf8f5',
  100: '#f1ede7',
  200: '#e4ddd3',
  300: '#d4c8b9',
  400: '#a99c8c',
  500: '#7d7164',
  600: '#5f554b',
  700: '#4a4037',
  800: '#332c25',
  900: '#211c17',
  950: '#14100d',
  light: '#e4ddd3',
  main: '#7d7164',
  dark: '#4a4037',
}

export const primary = {
  lighter: '#a78bfa',
  main: '#7c3aed',
  dark: '#5b21b6',
}

export const secondary = {
  lighter: '#d6d3d1',
  light: '#a8a29e',
  main: '#57534e',
  dark: '#44403c',
  darker: '#292524',
  contrastText: grey[50],
}

export const info = {
  lighter: '#d6d3d1',
  light: '#a8a29e',
  main: '#78716c',
  dark: '#57534e',
  darker: '#292524',
  contrastText: grey[50],
}

export const success = {
  lighter: '#dcfce7',
  light: '#86efac',
  main: '#15803d',
  dark: '#166534',
  darker: '#14532d',
  contrastText: grey[50],
}

export const warning = {
  lighter: '#fef3c7',
  light: '#fbbf24',
  main: '#b45309',
  dark: '#92400e',
  darker: '#78350f',
  contrastText: grey[800],
}

export const error = {
  lighter: '#fee2e2',
  light: '#ef4444',
  main: '#b91c1c',
  dark: '#991b1b',
  darker: '#7f1d1d',
  contrastText: grey[50],
}

export const common = {
  black: '#000000',
  white: '#FFFFFF',
}

export const action = {
  hover: alpha(grey[500], 0.08),
  selected: alpha(grey[500], 0.16),
  disabled: alpha(grey[500], 0.8),
  disabledBackground: alpha(grey[500], 0.24),
  focus: alpha(grey[500], 0.24),
  hoverOpacity: 0.08,
  disabledOpacity: 0.48,
  active: grey[400],
}

const base = {
  primary,
  secondary,
  info,
  success,
  warning,
  error,
  grey,
  common,
  divider: alpha(grey[500], 0.2),
  action,
}

export function palette(mode) {
  switch (mode) {
    case 'dark':
      return {
        mode: 'dark',
        text: {
          primary: grey[50],
          secondary: grey[400],
          disabled: grey[600],
          icon: grey[50],
        },
        background: {
          default: grey[950],
          paper: grey[900],
          neutral: grey[200],
        },
        ...base,
      }
    case 'light':
    default:
      return {
        mode: 'light',
        text: {
          primary: grey[950],
          secondary: grey[700],
          disabled: grey[500],
          icon: alpha(grey[800], 0.8),
        },
        background: {
          default: grey[50],
          paper: common.white,
          neutral: grey[200],
        },
        ...base,
      }
  }
}
